<template>
  <div class="ddcf-container">
    <el-row class="tcf-row">
      <el-col  class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="搜索关键字">
              <el-input v-model="searchForm.search" placeholder="关键字搜索" @keyup.enter.native="Search"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-document" @click="orderSplitRecord">拆分记录</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content" >
            <el-row>
              <el-col :span="24" v-loading="loading">
                <el-table
                  :data="tableData"
                  stripe
                  :row-style="{cursor: 'pointer'}"
                  @row-click="openDetails"
                  style="width: 100%">
                  <el-table-column
                    label="订单号"
                    width="140"
                    fixed
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.order_num}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="经销商"
                    width="120"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span :style="scope.row.all_name && scope.row.all_name.indexOf('VIP') > -1 ? 'font-weight: bold; color: #389e0d; font-style: italic;' : ''">
                        {{ scope.row.all_name }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="订单类型"
                    width="110"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span v-if="scope.row.mark===0">正单</span>
                      <span v-if="scope.row.mark===1">客改单</span>
                      <span v-if="scope.row.mark===2">增补单</span>
                      <span v-if="scope.row.mark===3">色板单</span>
                      <span v-if="scope.row.mark===4">售后单</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="品牌"
                    width="130"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.brand_name}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="上次操作时间"
                    width="170"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span v-if="scope.row.status==5">{{scope.row.assess_time}}</span>
                      <span v-if="scope.row.status==6">{{scope.row.allot_time}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="详细地址"
                    min-width="200"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.address}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    width="120"
                    fixed="right"
                    align="center"
                    label="操作">
                    <template slot-scope="scope">
                      <el-button size="mini" icon="el-icon-copy-document" @click.stop="allot(scope.row)">立即拆分</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-if="total>0"
                  background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-sizes="[20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total">
                </el-pagination>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      title="拆分订单"
      :visible.sync="editVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <el-form ref="editForm" :model="editForm" :rules="editRules"  label-position="right" label-width="90px" size="small">
        <el-form-item label="操作订单" prop="ordername">
          <el-input v-model="editForm.ordername" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="拆分个数" prop="num">
          <el-input-number v-model="editForm.num"  @change="handleChange" :min="2" :max="10"></el-input-number>
          <span style="color:#99a9bf;font-size: 12px;margin-left: 10px">最少拆分2个，最多不超过10个</span>
        </el-form-item>
        <el-form-item v-for="(item, index) in editForm.orderInfo" :key="item.key" :label="'订单'+(index+1)" :prop="'orderInfo.' + index +'.address'" :rules="editRules.address">
          <el-input v-model="item.address" maxlength="100"></el-input>
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" :loading="editloading" @click="subEdit('editForm')">立即提交</el-button>
          <el-button @click="editVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getOrderList, orderSplit } from '@/api/erp'

export default {
  name: 'ddcf',
  computed: {
    user: getUser
  },
  data() {
    return {
      searchForm: {
        search: ''
      },
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      editVisible: false,
      editloading: false,
      editForm: {
        orderid: '',
        ordername: '',
        address: '',
        num: 2,
        orderInfo: []
      },
      editRules: {
        ordername: [{ required: true, message: '请选择订单', trigger: 'blur' }],
        num: [{ required: true, message: '请输入拆分个数', trigger: 'blur' }],
        address: [{ required: true, message: '请输入订单地址', trigger: 'blur' }]
      }
    }
  },
  created() {
    this.getData()
  },
  methods: {
    orderSplitRecord() {
      this.$router.push({ path: '/work/order_split_record' })
    },
    Search() {
      if (this.searchForm.search !== null && this.searchForm.search.trim() !== '') {
        this.currentPage = 1
        this.getData()
      } else {
        this.searchForm.search = ''
        this.getData()
      }
    },
    getData() {
      this.loading = true
      const data = {
        content: this.searchForm.search,
        page: this.currentPage,
        limit: this.pageSize,
        mark: '5,6',
        userid: this.user.dUserid,
        groupid: this.user.dGroupid,
        role: this.user.role
      }
      getOrderList(data).then(response => {
        this.loading = false
        this.tableData = response.data
        this.total = response.total
      }).catch(() => {
        this.loading = false
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    openDetails(row) {
      this.$router.push({ path: '/work/order/' + row.order_id })
    },
    allot(row) {
      this.editForm.orderid = row.order_id
      this.editForm.ordername = row.order_num + ' / ' + row.address
      this.editForm.num = 2
      this.editForm.address = row.address
      this.editForm.orderInfo = [{ address: this.editForm.address + '（第一批）' }, { address: this.editForm.address + '（第二批）' }]
      this.editVisible = true
    },
    toChinese(values) {
      const chin_list = ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十']
      const sn = parseInt(values)
      return chin_list[sn - 1]
    },
    handleChange(val, oldValue) {
      if (val > oldValue) {
        for (let i = oldValue; i < val; i++) {
          this.editForm.orderInfo.push({ address: this.editForm.address + '（第' + this.toChinese(i + 1) + '批）' })
        }
      } else if (val < oldValue) {
        for (let i = this.editForm.orderInfo.length; i > val; i--) {
          this.editForm.orderInfo.splice((i - 1), 1)
        }
      }
    },
    subEdit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.SubAllotOrder()
        } else {
          return false
        }
      })
    },
    SubAllotOrder() {
      if (!this.editloading) {
        this.editloading = true
        let names = []
        for (let oi of this.editForm.orderInfo) {
          names.push(oi.address)
        }
        let namesStr = JSON.stringify(names)
        namesStr = namesStr.substring(1, namesStr.length - 1)
        const data = {
          userid: this.user.dUserid,
          orderid: this.editForm.orderid,
          num: this.editForm.num,
          names: namesStr
        }
        orderSplit(data).then(response => {
          this.$message({
            message: '订单拆分成功',
            type: 'success'
          })
          this.editloading = false
          this.editVisible = false
          this.getData()
        }).catch(() => {
          this.editloading = false
        })
      } else {
        return false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.ddcf-container {
  .tcf-row{
    .card{
      .card-body{
        .card-title{
          .search-mode{
            width: 400px;
            position: relative;
            float: right;
            margin-top: -10px;
            .search-input{
              background-color: #F2F6FC;
              border:0;
              height: 40px;
              line-height: 40px;
              border-radius: 4px;
              color: #606266;
              padding: 0 140px 0 15px;
              -webkit-appearance: none;
              font-size: 12px;
              width: 100%;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              outline: 0;
              &::-webkit-input-placeholder {
                color: #C0C4CC;
              }
              &::-ms-input-placeholder {
                color: #C0C4CC;
              }
            }
            .search-btn{
              position: absolute;
              right: 100px;
              height: 40px;
              width: 40px;
              line-height: 40px;
              top: 0;
              border: 0;
              background: transparent;
              text-align: center;
              padding: 0;
            }
            .record-box{
              position: absolute;
              width: 100px;
              height: 40px;
              line-height: 40px;
              right:0;
              top: 0;
            }
          }
        }
        .card-content{
          .group-filter{
            width: 100%;
            padding: 0 30px 0 0 ;
            margin: 0 ;
            position: relative;
            li{
              width: 100%;
              list-style: none;
              position: relative;
              padding-left: 20px;
              padding-top: 15px;
              padding-bottom: 15px;
              cursor: pointer;
              border-radius: 2px;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              &.active{
                background: #f5f7fa;
                color:#409EFF;
              }
              &:hover{
                color:#409EFF;
              }
            }
          }
          .el-table::before{
            height: 0!important;
          }
          .el-pagination{
            margin-top: 20px;
          }
        }
      }
    }
  }
}
</style>
